import { useState, useEffect } from 'react';
import { ContactFormConfig } from '../types/ContactForm';

interface UseFieldsTabStateProps {
    config: ContactFormConfig;
    updateConfig: (property: string, value: unknown) => void;
}

export const useFieldsTabState = ({ config, updateConfig }: UseFieldsTabStateProps) => {
    const [activeStep, setActiveStep] = useState(1);
    const [focusedOption, setFocusedOption] = useState<{ fieldIndex: number, optionIndex: number } | null>(null);
    const [justCreatedOption, setJustCreatedOption] = useState<{
        fieldIndex: number,
        optionIndex: number
    } | null>(null);
    const [showMultistepUI, setShowMultistepUI] = useState(false);
    const [showDescription, setShowDescription] = useState(false);

    useEffect(() => {
        if (focusedOption) {
            const timer = setTimeout(() => {
                const input = document.querySelector(`[data-option-field="${focusedOption.fieldIndex}-${focusedOption.optionIndex}"]`) as HTMLInputElement;
                if (input) {
                    input.focus();
                    input.setSelectionRange(0, 0);
                }
                setFocusedOption(null);
            }, 100);
            return () => clearTimeout(timer);
        }
    }, [focusedOption]);

    useEffect(() => {
        if (!config.steps || config.steps.length === 0) {
            updateConfig('steps', [
                {id: '1', title: 'Schritt 1', description: 'Grundlegende Informationen'}
            ]);
            updateConfig('isMultiStep', false);
        }
    }, []);

    useEffect(() => {
        const stepCount = config.steps?.length || 1;
        const isMultiStep = stepCount > 1;
        updateConfig('isMultiStep', isMultiStep);

        if (isMultiStep) {
            setShowMultistepUI(true);
        } else if (stepCount === 1) {
            setShowMultistepUI(false);
        }
    }, [config.steps?.length]);

    useEffect(() => {
        const currentStep = config.steps?.[activeStep - 1];
        if (currentStep?.description && currentStep.description.trim() !== '') {
            setShowDescription(true);
        } else {
            setShowDescription(false);
        }
    }, [activeStep, config.steps]);

    return {
        activeStep,
        setActiveStep,
        focusedOption,
        setFocusedOption,
        justCreatedOption,
        setJustCreatedOption,
        showMultistepUI,
        setShowMultistepUI,
        showDescription,
        setShowDescription
    };
};

